module.exports = __webpack_public_path__ + "img/3-r.63eafe78.png";